import Box from "ds/components/Box";
import ListEntitiesItemDescriptionMultipleLines from "components/ListEntitiesItem/Description/MultipleLines";

import { CellComponentProps } from "../types";

type RolesListItemDescriptionCellProps = CellComponentProps;

const RolesListItemDescriptionCell = ({ role }: RolesListItemDescriptionCellProps) => {
  if (!role.description) {
    return null;
  }

  return (
    <Box direction="row" align="center">
      <ListEntitiesItemDescriptionMultipleLines
        lines={1}
        hasChevronLink
        description={role.description}
      />
    </Box>
  );
};

export default RolesListItemDescriptionCell;
